import util from '@bmp-vue/core/api/util'

const controller = 'Events'
export default Object.assign({}, util.GetCrud(controller, null))
